import {Component, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-pdf-page-footer',
    templateUrl: './pdf-page-footer.component.html',
    styleUrls: ['./pdf-page-footer.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PdfPageFooterComponent {

}
